import { Box, Grid, Container, Typography } from '@mui/material';
import ContactForm from 'Components/ContactForm';
import PageWrapper from 'Components/PageWrapper';
import ScrollTopFab from 'Components/ScrollTopFab';
import { useConfig } from 'store/state';

const Component = () => {
  const [config] = useConfig();

  return (
    <>
      <ScrollTopFab />
      <PageWrapper>
        <Container fixed sx={{ mb: 5 }}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Box
                sx={{
                  pt: 5,
                  pb: 5,
                }}
              >
                <Typography variant="h3">CONTACT US</Typography>
                Hello! How can we help you?
              </Box>
              <Box>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography variant="h5">
                      Give Us a Call
                      <br />
                    </Typography>
                    {config.contact_phone}
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography variant="h5">
                      Corporate HQ
                      <br />
                    </Typography>
                    <Typography component="a" href="https://goo.gl/maps/AHTMtmMw6JfLhpqz8">
                      {config.contact_address}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }} />
            <Grid size={{ xs: 12, lg: 6 }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d148097.76626577487!2d-105.19721839422455!3d39.99388020861574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876bf4e5817d62f1%3A0x306771f4a85a2ac4!2s601%20S%20Public%20Rd%2C%20Lafayette%2C%20CO%2080026!5e0!3m2!1sen!2sus!4v1680841461498!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{
                  minHeight: '400px',
                  border: 0,
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Map of location"
              ></iframe>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <ContactForm />
            </Grid>
          </Grid>
        </Container>
      </PageWrapper>
    </>
  );
};

export default Component;
